import { render } from "./LicenseSubscription.vue?vue&type=template&id=84add3e2&ts=true"
import script from "./LicenseSubscription.vue?vue&type=script&lang=ts"
export * from "./LicenseSubscription.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__